export default __webpack_public_path__ + "static/media/H1006.1.0688473b.mp3";